export default {
  COMMUNIY_UPDATES ({ communityUpates }) {
    return communityUpates
  }
}
